import { useSession } from '~hooks/useSession';

import { tags } from '../tagNames';
import { useUserTags } from '../useUserTags';

export const useIsEmailConfirmRequired = () => {
	const { isDemoUser, isSuccess } = useSession();
	const { userTags, isLoading } = useUserTags();

	const isConfirmRequired =
		isSuccess && !isDemoUser && userTags.includes(tags.emailConfirmRequired);

	return [isConfirmRequired, isLoading];
};
